var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "4jceuc5cja",
    d: "M0.001 -0.003L25 -0.003 25 14.999 0.001 14.999z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .003)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ga1vmhnvob",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4jceuc5cja"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA57",
    d: "M24.553 12.352h-1.786V.88c0-.487-.4-.882-.892-.882H3.125c-.494 0-.893.395-.893.882v11.473H.446c-.246 0-.446.198-.446.441C0 14.013 1 15 2.233 15h20.535C24 15 25 14.012 25 12.793c0-.243-.2-.44-.447-.44",
    mask: "url(#ga1vmhnvob)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C93D0B",
    d: "M3.729 12.298L21.271 12.298 21.271 1.609 3.729 1.609z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#C93D0B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.73.847c0 .126-.102.228-.23.228-.127 0-.23-.102-.23-.228s.103-.228.23-.228c.128 0 .23.102.23.228M4.365 13.572c0 .258-.212.467-.473.467H1.057c-.26 0-.472-.21-.472-.467h3.781z",
    transform: "translate(10 .003)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighSchool);
export default __webpack_public_path__ + "static/media/highSchool.6dfc10bcddcc000d9d7891b3d760b92e.svg";
export { ForwardRef as ReactComponent };